import React from 'react';

import view, { isValidViewMode } from '../../Enums';
import Component from '../Component';
import { withResizer } from '../../HoCs';
import styles from './styles';
import OYOLogo from '../../resources/vectors/oyo';
import Facebook from '../../resources/vectors/Facebook';
import Twitter from '../../resources/vectors/Twitter';
import Instagram from '../../resources/vectors/Instagram';
import Youtube from '../../resources/vectors/Youtube';
import Linkedin from '../../resources/vectors/Linkedin';
import { guc } from '../../services/Localisation';
import { isEmptyList, isEmptyString } from '../../utils';
import { EVENT_ACTIONS, EVENT_CATEGORIES, logEvent } from '../../services/Analytics';
import { rowCenter } from '../../resources/styles';
import { getCtaLinkWithUtmParams } from '../../utils/campaignUtils';

class Footer extends Component {

    styles = styles;

    getViewMode = () => isValidViewMode(this.props.viewMode) ? this.props.viewMode
        : (this.getWidth() > 1024 ? view.DESKTOP : this.getWidth() >= 750 ? view.TAB : view.MOBILE);

    onLinkClicked = event_action => logEvent(EVENT_CATEGORIES.STATIC_FOOTER, event_action);

    defaultLinks = [
        { content: guc('partner_page'), href: '/', event_action: EVENT_ACTIONS.HOME_PAGE_LINK_CLICKED },
        { content: guc('terms_and_conditions'), href: guc('tnc_link'), target: '_blank', event_action: EVENT_ACTIONS.TNC_CLICKED }
    ];

    renderLinks = () => {
        const links = isEmptyList(this.props.links) ? this.defaultLinks : this.props.links;
        return <div style={this.gs('line_2')}>{
            links.map(({ content, href, target, event_action = content }, index) => <span key={index} style={rowCenter}>
                <a key={index} style={this.gs('link')} href={getCtaLinkWithUtmParams(href)} target={target} onClick={() => this.onLinkClicked(event_action)}>{content}</a>
                {index != links.length - 1 && <div style={this.gs('link_divider')} />}
            </span>)
        }</div>;
    }

    socialLinks = [
        { href: guc('facebook_link'), Icon: Facebook }, { href: guc('twitter_link'), Icon: Twitter },
        { href: guc('instagram_link'), Icon: Instagram }, { href: guc('youtube_link'), Icon: Youtube },
        { href: guc('linkedin_link'), Icon: Linkedin },
    ];

    renderSocialLink = ({ href, Icon }, index) => !isEmptyString(href) && <a href={href} target='_blank' key={index} style={this.gs('social_link')}><Icon color='rgb(74 74 74)' /></a>;

    renderSocialLinks = () => <div style={this.gs('social_links')}>
        {(isEmptyList(this.props.socialLinks) ? this.socialLinks : this.props.socialLinks).map(this.renderSocialLink)}
    </div>;

    render = () => <div style={this.gs('container')}>
        <div style={this.gs('line_1')}>
            <a to={getCtaLinkWithUtmParams('/')}><OYOLogo {...this.gs('logo_props')} style={this.gs('logo')} /></a>
            <div style={this.gs('worlds_fastest')}>{guc('the_worlds_fastest')}</div>
        </div>
        {this.renderLinks()}
        <div style={this.gs('line_3')}>
            {this.renderSocialLinks()}
            <div style={this.gs('company_name')}>© Oravel Stays Private Limited</div>
        </div>
    </div>;

}

export default withResizer(Footer);
